(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Warning', Warning)
        .factory('WarningConstant', WarningConstant);

    Warning.$inject = ['$resource'];
    WarningConstant.$inject = ['$resource'];

    function Warning ($resource) {
        var resourceUrl =  'api/warnings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getClone': {
                url: 'api/warnings/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function WarningConstant ($resource) {
        var resourceUrl =  'api/warnings/status';

        return $resource(resourceUrl, {}, {
            'update': { method:'PUT' }
        });
    }
})();
